import { createContext, useContext } from "react";

/**
 * Lightweight context so any descendant (header "+", mobile nav, keyboard
 * shortcut) can open the global command palette without prop-drilling.
 */
interface DashboardChrome {
  openPalette: () => void;
}

export const DashboardChromeContext = createContext<DashboardChrome>({
  openPalette: () => {},
});

export const useDashboardChrome = () => useContext(DashboardChromeContext);
